import React, { memo, useEffect, useMemo } from 'react';
import { useObservable } from 'react-use-observable';
import { numberToBRL } from 'v2/helpers/money';
import { financialStatementBlockedService } from 'v2/services/financialStatement/blocked';

import type { ListOrder } from 'v2/services/financialStatement/statement';

import useStyles from './styles';
import ContentTable from '../ContentTable';

type Props = {
  order: ListOrder;
  shouldDisableSortBtn: Function;
};

function Blocked({ order, shouldDisableSortBtn }: Props) {
  const classes = useStyles();

  useObservable(() => financialStatementBlockedService.loadData(order), [order]);

  const [balance] = useObservable(() => financialStatementBlockedService.getTotalBalance(), []);
  const [entries] = useObservable(() => financialStatementBlockedService.getFinancialStatementBlocked(), [], []);
  const [pagination] = useObservable(() => financialStatementBlockedService.getPaginationResponse(), []);
  const [isLoading] = useObservable(() => financialStatementBlockedService.isLoading(), []);

  const handlePagination = useMemo(
    () => ({
      onChangeRowsPerPage: (per_page: number) => {
        financialStatementBlockedService.setPagination({ ...pagination, ...{ per_page, current_page: 1, order } });
        document.getElementById('blocked_table').scrollIntoView();
      },
      onChangePage: (page: number) => {
        financialStatementBlockedService.setPagination({ ...pagination, ...{ current_page: page, order } });
        document.getElementById('blocked_table').scrollIntoView();
      },
    }),
    [pagination, order]
  );

  useEffect(() => entries && shouldDisableSortBtn(!entries?.length), [entries, shouldDisableSortBtn]);

  return (
    <>
      {!!entries?.length && !isLoading && (
        <div className={classes.topListWithTotal}>
          <div>
            <span className={classes.labelValue}>Total em lançamentos bloqueados:</span>
            <strong className={classes.mainValue}>{!isLoading && (numberToBRL(balance) || '-')}</strong>
          </div>
        </div>
      )}
      <ContentTable
        id='blocked_table'
        balanceLabel='Valor no dia'
        data={entries}
        pagination={pagination}
        handlePagination={handlePagination}
        loading={isLoading}
        showBlockedDetails
      />
    </>
  );
}

export default memo(Blocked);
